import { render } from "./ConsumoOxigeno.vue?vue&type=template&id=f84ffb0c&scoped=true"
import script from "./ConsumoOxigeno.vue?vue&type=script&lang=js"
export * from "./ConsumoOxigeno.vue?vue&type=script&lang=js"

import "./ConsumoOxigeno.vue?vue&type=style&index=0&id=f84ffb0c&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84ffb0c"]])

export default __exports__